"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _StyledOption = require("./StyledOption");
const Option = props => {
  const {
    className,
    innerRef,
    children,
    isDisabled,
    isFocused,
    isSelected
  } = props;
  return /*#__PURE__*/_react.default.createElement(_StyledOption.StyledOption, (0, _extends2.default)({
    className: className,
    ref: innerRef
    // TODO optionHeight should be moved to the LayoutContext.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    ,
    height: props.selectProps.optionHeight,
    isDisabled: isDisabled,
    isFocused: isFocused,
    isSelected: isSelected
  }, props.innerProps), children);
};
exports.Option = Option;
//# sourceMappingURL=Option.js.map